import { getBanners } from '~/src/api/banners';
import { SET_BANNERS_FOR_MAIN_PAGE } from '../actionTypes/main';
import { captureException } from '@sentry/node';

export const getBannersForMainPage = (domainCity, isAuth) => {
    return async dispatch => {
        await getBanners(domainCity, isAuth, 'main')
            .then(response => {
                return dispatch(setBannersForMainPage(response.data.items));
            })
            .catch(error => captureException(error));
    };
};


export const setBannersForMainPage = (bannerData) => ({
    type: SET_BANNERS_FOR_MAIN_PAGE,
    payload: bannerData
});
